export function megaMenu() {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activeLink = document.querySelector(
        '.menu-item-has-children:hover > a'
      );
      if (activeLink) {
        activeLink.blur();
      }
    }
  });
}
